<template>
  <!-- <div style="width: 100%"> -->
  <v-row class="align-center" style="overflow: hidden">
    <v-col
      md="4"
      lg="5"
      class="mb-0 pb-3 flex-grow-1"
      style="min-width: 100px; max-width: 100%"
    >
      <v-btn
        class="white--text rounded-card"
        color="fiscButton"
        @click="routeToReceipts"
        id="routeReceiptsBtn"
        v-if="unfiskReceipts.length !== 0 && !$route.name.includes('receipts')"
        >Broj nefiskaliziranih računa: {{ unfiskReceipts.length }}
      </v-btn>
    </v-col>

    <v-col
      cols="12"
      sm="12"
      md="8"
      lg="6"
      xl="7"
      class="d-flex align-center justify-end"
    >
      <v-text-field
        @click="showKbd"
        data-layout="normal"
        append-icon="mdi-magnify"
        clearable
        v-if="
          $route.meta.removeSearch ||
          registerMode === 'panel' ||
          registerMode === 'ai-crud'
            ? false
            : true
        "
        class="pr-5 pt-5"
        :style="{ 'max-width': $vuetify.breakpoint.mdAndUp ? '50%' : '100%' }"
        v-model="topSearch"
        @input="filterItems()"
        @click:clear="
          filterItems({ reset: true });
          searchItems({ reset: true });
        "
        :placeholder="
          $route.meta.filterSearch
            ? $t('$vuetify.filterPlaceholderLabel')
            : $t('$vuetify.searchLabel')
        "
        @keydown.enter="searchItems()"
      >
      </v-text-field>
      <v-btn
        class="glass-logout-btn"
        @click="logoutCashRegister"
        v-if="showCashRegLogout"
        elevation="0"
      >
        <div class="logout-inner">
          <v-icon small>mdi-logout</v-icon>
          <span class="logout-btn-name" :style="{ fontSize: logoutBtnFontSize }">{{ cashRegUser.name + " " + cashRegUser.surname }}</span>
        </div>
      </v-btn>
      <v-menu offset-y content-class="gear-menu-dropdown">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="glass-options-btn"
            v-bind="attrs"
            v-on="on"
            @keypress.enter.stop=""
            elevation="0"
          >
            <v-icon>mdi-cog</v-icon>
          </v-btn>
        </template>
        <v-list dense class="glass-menu-list">
          <v-list-item
            v-for="(item, index) in cashRegisterOptions"
            :key="index"
            class="glass-menu-item"
            @click="`${item.action()}`"
            @keypress.enter.prevent="`${item.action()}`"
          >
            <v-list-item-icon class="mr-3">
              <v-icon color="#3989C9" small>
                {{ index === 0 ? 'mdi-calendar-check' : 'mdi-cog-outline' }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title class="menu-item-title">{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- <v-tooltip bottom>
        <template
          v-if="$route.meta.removeGrid ? false : true"
          v-slot:activator="{ on, attrs }"
        >
          <v-btn v-on="on" v-bind="attrs" plain text @click="changeView">
            <v-icon v-if="listView">mdi-view-grid</v-icon>
            <v-icon v-else>mdi-view-list</v-icon>
          </v-btn>
        </template>
        <span>{{ listView ? "Prikazi kao grid" : "Prikazi kao listu" }}</span>
      </v-tooltip> -->
    </v-col>
    <change-template-dialog
      v-if="templatesDialogOpen"
      @selectTempate="changeCashRegisterTemplate"
      @closeTemplatesDialog="onCloseTemplatesDialog"
    ></change-template-dialog>
  </v-row>
  <!-- <v-container class="kbd"
v-if="!$vuetify.breakpoint.smAndDown" ref="keyboard" v-show="oskVisible" :style="{ 'max-width': width }">
      <div class="kbd-header"></div>
      <vue-touch-keyboard :options="oskOptions" :layout="layout" :cancel="hideKbd" :accept="accept" :input="input" />
    </v-container> -->
  <!-- </div> -->
</template>
<script>
import state from '@/state'
import applicationSettings from '@/mixins/applicationSettings'
import { auth, df } from '@/plugins/firebase'
import EventBus from '@/plugins/event-bus'
import ChangeTemplateDialog from '@/components/top-bar/components/ChangeTemplateDialog'
import onScreenKeyboard from '@/mixins/onScreenKeyboard'
import LogData from '@/model/LogData'
import log from '@/mixins/log'

export default {
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  mixins: [applicationSettings, onScreenKeyboard, log],
  components: {
    ChangeTemplateDialog
  },
  data: function (vm) {
    return {
      templatesDialogOpen: false,
      switchOnScreenKeyboard: true,
      registerMode: '',
      menu: false,
      topSearch: '',
      cashRegisterOptions: [
        { title: vm.$t('$vuetify.cashRegister.closeBalanceTitle'), action: vm.closeBalance },
        { title: 'Konfiguracija blagajne', action: vm.showTemplateDialog }
        // { title: vm.$t('$vuetify.cashRegister.createRegisterReport'), action: vm.createReport }
      ],
      unfiskReceipts: [],
      listeners: [],
      showCashRegLogout: false,
      switchOnOrdersTable: false,
      onLine: true,
      selectedPrinter: {}
    }
  },
  beforeDestroy () {
    EventBus.$off('set-selected-printer')
    if (this.listeners) {
      this.detachListeners()
    }
  },
  async created () {
    this.registerMode = await this.setRegisterTemplate()
    this.selectedPrinter = state.getSelectedPrinter()
  },
  mounted () {
    EventBus.$on('set-selected-printer', (printer) => {
      this.selectedPrinter = printer
      // console.log('this.selectedPrinter', this.selectedPrinter)
    })

    if (state.getCurrentCompany().id !== '') {
      let query = df.collection(`receipts/${state.getCurrentCompany().id}/receipts`)
        .orderBy('issue_date_time', 'desc')

      const now = parseInt(
        (new Date().getTime() / 1000).toFixed(0)
      )

      const tmp = new Date()
      tmp.setDate(tmp.getDate() - 2)

      const before = parseInt(
        (tmp.getTime() / 1000).toFixed(0)
      )
      query = query.where('fiscalize', '==', true).where('jir', '==', '').where('issue_date_time', '>=', before).where('issue_date_time', '<=', now)

      const listener = query
        .onSnapshot((doc) => {
          doc.docs.forEach((rec) => {
            this.unfiskReceipts.push(rec.data())
          })
          if (doc.docs.length === 0) {
            this.unfiskReceipts = []
          }
        }
        )

      this.listeners.push(listener)
    }

    const cashReg = state.getCashRegister()
    if (cashReg.login_type !== undefined && cashReg.login_type !== '' && cashReg.login_type !== 'DEFAULT') {
      this.showCashRegLogout = true
    }
  },
  computed: {
    cashRegUser () {
      const u = state.getCashRegisterUser()
      return u?.id ? u : state.getUser()
    },
    logoutBtnFontSize () {
      const u = this.cashRegUser
      const name = u ? (u.name + ' ' + u.surname) : ''
      const len = name.trim().length
      if (len <= 14) return '14px'
      if (len <= 22) return '13px'
      return '12px'
    },
    title () {
      return state.getCashRegister().name
    },
    titleFontSize () {
      const len = (this.title || '').length
      if (len <= 18) return '22px'
      if (len <= 30) return '18px'
      if (len <= 45) return '14px'
      return '12px'
    },
    listView () {
      return state.isListView()
    }
  },
  watch: {
    filter (val) {
      if (val !== this.topSearch) {
        this.topSearch = val
      }
    },
    search (val) {
      if (val !== this.topSearch) {
        this.topSearch = val
      }
    },
    registerMode (val) {
      // console.log('VAL', val)
    }
  },
  methods: {
    onCloseTemplatesDialog () {
      this.templatesDialogOpen = false
    },
    showTemplateDialog () {
      this.templatesDialogOpen = true
    },
    changeCashRegisterTemplate () {
      this.hideKbd()
      if (state.getRegisterType() === 'cash') {
        state.setRegisterType('cash')
        this.registerMode = 'cash'
      } else if (state.getRegisterType() === 'panel') {
        state.setRegisterType('panel')
        this.registerMode = 'panel'
      } else if (state.getRegisterType() === 'ai-caffe-wide') {
        state.setRegisterType('ai-caffe-wide')
        this.registerMode = 'ai-caffe-wide'
      } else if (state.getRegisterType() === 'ai-crud') {
        state.setRegisterType('ai-crud')
        this.registerMode = 'ai-crud'
      } else if (state.getRegisterType() === 'ai-compact') {
        state.setRegisterType('ai-compact')
        this.registerMode = 'ai-compact'
      }
      this.saveRegisterType()
      EventBus.$emit('change-register-template')
    },
    async saveRegisterType () {
      const me = this
      df.doc(`cash_registers/${state.getCashRegister().id}`).update({ register_template: this.registerMode })
        .then(() => {
          // console.log(`Register template changed to ${this.registerMode}`)
        })
        .catch(() => {
          me.hideLoader()
          me.showMsgBox({ text: 'Pogreška prilikom promjene templatea blagajne', actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
        })
    },
    async setRegisterTemplate () {
      const register = await df.doc(`cash_registers/${state.getCashRegister().id}`).get()
      if (register && register.data()) {
        const doc = register.data()
        if (doc && doc.register_template) {
          state.setRegisterType(doc.register_template)
        } else {
          state.setRegisterType('cash')
        }
      } else {
        state.setRegisterType('cash')
      }
      return state.getRegisterType()
    },
    async logoutCashRegister () {
      this.showLoader()

      if (state.getCurrentCompany().save_log) {
        this.prepareLogCall()
      }
      // const register = await df.doc(`cash_registers/${state.getCashRegister().id}`).get()

      // const cashRegUser = state.getCashRegisterUser()
      // const cashRegUserName = cashRegUser.name + ' ' + cashRegUser.surname
      // if (register.reserved_by !== '' && register.reserved_by === cashRegUserName) {
      state.setCashRegisterUser({ id: undefined })
      df.doc(`cash_registers/${state.getCashRegister().id}`).update({ reserved_by: '' })
        .then(() => {
          console.log('success')
          this.$router.push({
            name: 'pointOfSale.cashRegisters',
            params: {
              companyId: state.getCurrentCompany().id,
              locationId: state.getPointOfSale().id
            }
          })
        })
        .catch(() => {
          this.hideLoader()
          this.showMsgBox({ text: 'Pogreška prilikom zapisa podataka', actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
          this.$router.push({
            name: 'pointOfSale.cashRegisters',
            params: {
              companyId: state.getCurrentCompany().id,
              locationId: state.getPointOfSale().id
            }
          })
        })
        .finally(() => {
          this.hideLoader()
        })

      // }
    },
    prepareLogCall () {
      var req = new LogData()

      let userId = auth.currentUser.uid
      if (state.getCashRegisterUser().id && state.getCashRegisterUser().id !== '') {
        userId = state.getCashRegisterUser().id
      }

      req.action_name = 'Odjava'
      req.action_id = '2'
      req.user_id = userId

      this.setLog(req)
    },
    routeToReceipts () {
      this.$router.push({
        name: 'pointOfSale.receipts',
        params: {
        }
      })
    },
    changeView () {
      state.setListView(!state.isListView())
    },
    createReport () {
      if (!state.events) return
      state.events.createReport = true
    },
    closeBalance () {
      if (!state.events) return
      state.events.closeBalance = true
    },
    searchItems (reset = false) {
      if (reset) {
        this.search = ''
      } else {
        if (this.topSearch) {
          this.search = this.topSearch
        } else {
          this.search = ''
        }
      }
    },
    filterItems (reset = false) {
      if (reset) {
        this.filter = ''
      } else {
        if (this.topSearch) {
          this.filter = this.topSearch
        } else {
          this.filter = ''
          this.search = '' // reset search on input event if there is no text
        }
      }
    }
  }
}
</script>
<style scoped>
/* TopBar Register Title */
.topbar-register-title {
  font-weight: 700 !important;
  background: linear-gradient(
    135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 1) 50%,
    rgba(97, 84, 164, 1) 100%
  ) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  letter-spacing: 0.5px !important;
  line-height: 1.25 !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 3 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  transition: font-size 0.2s ease !important;
}

/* Glass Logout Button */
.glass-logout-btn {
  background: rgba(244, 67, 54, 0.9) !important;
  color: white !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.25) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
  padding: 0 14px !important;
  height: 40px !important;
  max-width: 160px !important;
  min-width: 0 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  margin-right: 8px !important;
}

.logout-inner {
  display: flex;
  align-items: center;
  gap: 6px;
  max-width: 130px;
  overflow: hidden;
  height: 100%;
}

.logout-inner .v-icon {
  flex-shrink: 0;
}

.logout-btn-name {
  min-width: 0;
  font-weight: 600;
  line-height: 1.25;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.glass-logout-btn:hover {
  background: rgba(244, 67, 54, 1) !important;
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 20px rgba(244, 67, 54, 0.4) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.glass-logout-btn .v-icon {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.glass-logout-btn:hover .v-icon {
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
}

/* Glass Options Button - Soft Style */
.glass-options-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #3989c9 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.15) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px !important;
  min-width: 40px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.glass-options-btn:hover {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  border-color: rgba(57, 137, 201, 0.3) !important;
  transform: translateY(-1px);
}

.glass-options-btn .v-icon {
  font-size: 20px !important;
  color: #3989c9 !important;
}

/* Glass Menu Dropdown */
.gear-menu-dropdown {
  margin-top: 8px !important;
}

.glass-menu-list {
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 24px rgba(0, 179, 190, 0.15) !important;
  padding: 8px 0 !important;
  min-width: 260px !important;
  overflow: hidden;
}

/* Menu Items */
.glass-menu-item {
  cursor: pointer !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 8px !important;
  margin: 0 8px 4px 8px !important;
  padding: 12px 16px !important;
  min-height: 48px !important;
}

.glass-menu-item:hover {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.08) 0%,
    rgba(57, 137, 201, 0.06) 100%) !important;
  transform: translateX(4px);
  box-shadow: inset 4px 0 0 rgba(0, 179, 190, 0.6);
}

.glass-menu-item .v-list-item__icon {
  margin-right: 12px !important;
  min-width: 24px !important;
}

.menu-item-title {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
}

</style>
